<template>
    <div class="content-view">
        <menus />

        <h2 class="fs-24 text-center fc-theme">关键词卡首屏</h2>
        <p class="subtitle text-center fs-14 fc-666">主要用于解决新品在没排名，补手淘搜索关键词流量</p>
        <div v-if="codeName">
            <top-price :code="codeName"></top-price>
        </div>
        <el-alert type="warning" :closable="false" class="marginT-20">
            <div slot="title" class="pause-top-tip">
                功能说明：请不要用一级词去卡屏，容易卡不上。<br>
                有权重！有权重！有权重！重要的事情说三遍！<br>
                备注：关键字卡首屏，如果自己进入的话会显示【淘内免费其他】，这个是淘宝对于自己进入店铺或多次进入店铺的人会显示，只要叫没有进入过你店铺的人进入就可以看到【手淘搜索】了。
            </div>
        </el-alert>
        <div class="flex">
            <div class="flex-3">
                <div class="flex marginT-20">
                    <el-button type="primary" @click="changeHandler('1')" :plain="activeMarkingType != '1'">高级版</el-button>
                    <el-button class="marginL-20" type="primary" @click="changeHandler('2')" :plain="activeMarkingType != '2'">普通版(免费)</el-button>
                    <el-button class="marginL-20" type="primary" @click="changeHandler('3')" :plain="activeMarkingType != '3'">新品卡首屏</el-button>
                </div>
                <div class="fc-666 marginT-10" v-if="activeMarkingType == 1">
                    注：关键词卡首屏（高级版）：可将任意销量的宝贝卡在搜索结果前几位（<span class="fc-red">如果短词蓝海词搜索不到，建议适当将词加长进行卡屏</span> ）重点！重点！不卡价格，不卡地区，不卡属性，不卡任何参数）一次生成多人可用(有效期30天)
                </div>

                <div class="flex fc-666 marginT-10" v-if="activeMarkingType != 3">
                    <div class="marginR-10">生成淘口令需额外增加<span class="fc-theme">{{configData.generate_password_point}}</span>点券</div>
                    <div v-if="activeMarkingType == 2">生成稳定版二维码需额外增加<span class="fc-theme">1</span>点券</div>
                </div>

                <div class="flex fc-666 marginT-10" v-if="activeMarkingType == 3">
                    <div class="marginR-10">用户操作扫码必须退出淘宝APP账户，先扫码访问宝贝卡首屏，进行收藏或购买行为时，再根据提示登录账户进行后续操作。</div>
                </div>

                <el-form class="marginT-50" label-width="100px" label-position="left">
                    <el-form-item label="搜索关键词：">
                        <el-input type="text" v-model="form.keyword" placeholder="请输入宝贝标题中包含的关键词"></el-input>
                    </el-form-item>
                    <el-form-item label="商品链接：">
                        <el-input type="text" v-model="form.url" placeholder="请输入您的宝贝链接或宝贝ID"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <div v-if="activeMarkingType == 2">
                            <el-badge value="会员免费" class="item">
                                <el-button type="danger" @click="onSubmit" :loading="loading">点击生成二维码 </el-button>
                            </el-badge>
                            <!--<el-button type="info" class="item" plain @click="onSubmit('tkl')">点击生成淘口令</el-button>-->
                            <el-badge value="付费" class="item bg-none">
                                <el-button type="danger" plain @click="onSubmit('', 'stable')" :loading="loading">生成稳定版二维码</el-button>
                            </el-badge>
                        </div>
                        <div v-else>
                            <el-button class="item" type="danger" @click="onSubmit" :loading="loading">点击生成二维码 </el-button>
                            <!--<el-button type="info" class="item" plain @click="onSubmit('tkl')">点击生成淘口令</el-button>-->
                            <!--<el-button disabled class="item" type="danger" @click="onSubmit">该功能已失效 </el-button>-->
                            <!--<el-button disabled type="info" class="item" plain @click="onSubmit('tkl')">该功能已失效</el-button>-->
                        </div>
                    </el-form-item>
                </el-form>
                <tklShow v-if="tklData.password" :password="tklData.password"></tklShow>
                <p v-if="showPt" style="padding-left: 110px;">该商品不支持高级版，已经生成普通版的卡首屏码</p>
                <div v-show="showQr" class="showqrcode flex">
                    <div class="qrcode" ref="qrcode" id="qrcode"></div>
                    <div class="howuse">
                        <el-button @click="dialogVisible = true" type="text">如何使用？</el-button>
                    </div>
                </div>
            </div>
            
            <div class="flex-2 marginL-20">
                <el-card class="box-card tip-card" v-if="activeMarkingType != 3">
                    <div slot="header" class="clearfix">
                        <el-tabs>
                            <el-tab-pane label="关键词卡首屏"></el-tab-pane>
                        </el-tabs>
                    </div>
                    <div>
                        <div class="title marginT-10 fc-theme fs-18">功能介绍</div>
                        <div class="content fs-14 fc-666">
                            1、输入相应的关键词和商品链接，会免费生成一个二维码。买家通过扫描这个二维码，商品会在搜索结果页比较靠前的位置。<br>
                            2、二维码是通过特定的代码制作出的淘口令，买家扫描二维码后，商品会提高相应的排名。<br>
                            3、新品没排名可使用此功能，买手可通过扫描生成的二维码，快速找到商品，提高商品关键词流量。<br>
                            4、生成稳定版二维码，可以快速获得卡首屏二维码，不会出现并发导致使用报错。
                        </div>
                        <div class="title marginT-10 fc-theme fs-18">使用场景</div>
                        <div class="content fs-14 fc-666">
                            1、新品上架没有排名，没有流量，可通过使用此功能提升新品排名。<br>
                            2、商家想快速精准地做单，提高搜索权重。
                        </div>
                        <div class="title marginT-10 fc-theme fs-18">注意</div>
                        <div class="content fs-14 fc-666">
                            1、关键词必须是标题中所包含的词，不可以是关键词延伸出来的词，否则无效果。<br>
                            2、新品使用此功能时，选择的关键词尽量长一点，但也不要全标题卡首屏。全标题卡首屏提升的权重不会很高甚至没有变化。<br>
                            3、不要用一级词卡屏，新品在一级词下的权重太低，很大概率会没有效果。<br>
                            4、新品卡出来之后，若有加购、货比三家等一系列操作的加持，商品所提升的权重会更高。<br>
                            5、测试时，尽量用近期没有访问过商品的账号，避免个性化推荐影响结果。<br>
                            6、接口合作请加微信{{getkfWx()}} 
                        </div>
                    </div>
                </el-card>

                <el-card class="box-card tip-card" v-if="activeMarkingType == 3">
                    <div slot="header" class="clearfix">
                        <el-tabs v-model="xinPin">
                            <el-tab-pane label="功能简介" name="gnjj">
                                <div>
                                    <div class="content marginT-10 fs-14 fc-666">
                                        新品卡首屏使用商品标题中的关键词实时生成二维码，将推广的新品以二维码扫码形式搜索访问展示在手淘搜索的页面首屏，可以快速精准提升商品的关键词搜索权重。
                                    </div>

                                    <div class="title marginT-10 fc-theme fs-18">注意事项</div>

                                    <div class="content fs-14 fc-666">
                                        1、生成的二维码不能保证100%能卡首屏成功，如果扫码没找到自己的宝贝，可以尝试将宝贝属性补充完整或者调整搜索的关键词，等待一段时间后在进行尝试。<br/><br/>

                                        2、搜索的关键词必须是宝贝标题中所包含的词。<br/><br/>

                                        3、用户操作扫码需退出淘宝APP账户，先扫码访问宝贝卡首屏，进行收藏或购买行为时，再根据提示登录账户进行后续操作。<br/><br/>

                                        4、新品卡首屏不卡价格，不卡地区，不卡属性，不卡任何参数。<br/><br/>

                                        5、建议宝贝有一定的基础销量，宝贝卡到首屏更容易。<br/><br/>

                                        6、部分宝贝如图书类特征不明显，卡不出效果，建议更换其他类别商品进行尝试。
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="功能用途" name="gnyt">
                                <div class="content marginT-10 fs-14 fc-666">
                                    1、新品刚发布希望通过搜索词方式寻找商品，可以用这个功能扫码找到。<br /><br />
                                    2、商家想快速精准地提高搜索权重。务必注意搜索词尽可能用标题中词。
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="消费说明" name="xfsm">
                                <div class="content marginT-10 fs-14 fc-666">
                                    1、非会员用户生成成功一次5点券，会员用户生成成功一次2点券。<br /><br />
                                    2、生成失败不扣取任何点数，充值1元到账100点券，多充值可以向客服索要会员。<br /><br />
                                    3、接口合作请加微信{{getkfWx()}} 
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </el-card>
            </div>
        </div>

        <first-pause-record ref="record" method="firstScreen"></first-pause-record>
        
        <div class="tip-card marginT-50">
            <el-card class="box-card">
                <div slot="header">
                    <span class="fs-16">什么是关键词卡首屏?</span>
                </div>
                <div class="li-content">
                    通过特定的代码制作出的淘口令，当别人使用手机淘宝打开了这种口令，就会跳转至手淘搜索页，此时你指定的单品将会出现在手淘搜索首屏的位置。
                </div>
            </el-card>
            <el-card class="box-card">
                <div slot="header">
                    <span class="fs-16">关键词卡首屏有什么用?</span>
                </div>
                <div class="li-content">
                    使用任意关键词+商品链接生成卡首屏淘口令，通过淘口令进行传播，将指定的宝贝通过关键词搜索显示在手机淘宝搜索页面首屏，快速精准做销量，提升搜索权重。
                </div>
            </el-card>
            <el-card class="box-card">
                <div slot="header">
                    <span class="fs-16">资深运营支招?</span>
                </div>
                <div class="li-content">
                    卡出来之后，先加购物车，然后去货比三家，随便拍任何一家的同行产品不要付款，过10分钟后，再让补手付款自己的订单即可，最后取消掉同行的。
                </div>
            </el-card>
            <el-alert type="warning" :closable="false" class="marginT-20">
                <div slot="title" class="pause-top-tip">
                    淘宝于2017-11-22已屏蔽旧版卡首屏接口，导致卡首屏功能全面失效。<br>
                    我们在第一时间更换了卡首屏的新接口，新接口卡位是随机位置，根据关键词的权重排位，所以不一定是在首条位置。<br>
                    现在即使只显示1个宝贝，只要点进去，也有效果。生意参谋【实时访客】有记录搜索关键词进店。
                </div>
            </el-alert>
            <div class="marginT-20">
                <img src="https://pic.rmb.bdstatic.com/bjh/be2caa65208d4671b41a5e9e6c3bfcc6.png" alt="">
            </div>
        </div>
        <el-dialog
            title="如何使用"
            :visible.sync="dialogVisible">
            <div class="flex">
                <div class="flex-1">
                    <img src="http://www.wangmaijia.cn/images/ylcsale/new_ksp_ewm_course1.png" alt="">
                    <p class="marginT-10">步骤1：搜狗浏览器打开扫一扫，<br>（搜索框最右边那个小相机）</p>
                </div>
                <div class="flex-1">
                    <img src="http://www.wangmaijia.cn/images/ylcsale/new_ksp_ewm_course2.png" alt="">
                    <p class="marginT-10">步骤2：跳转手淘后，点右上角分享<br>(苹果手机手淘扫一扫直接到这页的)</p>
                </div>
                <div class="flex-1">
                    <img src="http://www.wangmaijia.cn/images/ylcsale/new_ksp_ewm_course3.png" alt="">
                    <p class="marginT-10">步骤3：选择复制链接、微信、<br>QQ来获取卡首屏淘口令码<br>手淘搜索 流量来源）</p>
                </div>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import { mapState } from 'vuex'
import tklShow from '@/index/components/tklShow'
import FirstPauseRecord from './firstPauseRecord.vue'
import Menus from "../first_flow/_components/Menus"

export default {
    computed: {
        ...mapState(['configData', 'userData'])
    },
    data() {
        return {
            logMethod: 'seniorfirstscreen',
            loading: false,
            xinPin: 'gnjj',
            pricePreMonth: {},
            activeMarkingType: 1,
            tklData: {
                password: ''
            },
            dialogVisible: false,
            showQr: false,
            form: {
                keyword: '',
                url: ''
            },
            showPt: false, // 高级版展示普通版提示
            codeName: "",
        }
    },
    components: {
        tklShow,
        FirstPauseRecord,
        Menus,
    },
    methods: {
        async onSubmit(isTkl, isStable) {
            if (isTkl === 'tkl') {
                this.$message.warning("淘口令维护中")

                return false;
            }

            if (!localStorage.token) {
                this.$bus.emit('openLogin')
                return
            }
            if (!this.form.keyword || !this.form.url) {
                this.$message.error('请输入完整')
                return
            }

            const shopInfo = await this.getShopInfo()
            let url = ""
            if (this.activeMarkingType == 1) {
                window.checkDiscountPackage("seniorfirstscreen")
                // 高级版
                url = '/api/proxy/web/seniorfirstscreen';
            } else if (this.activeMarkingType == 2) {
                window.checkDiscountPackage("firstscreen")
                if (isStable == "stable") {
                    // 普通版稳定版
                    url = '/api/proxy/web/firstscreenV1'
                } else {
                    // 普通版
                    url = '/api/proxy/web/firstscreen'
                }
            } else {
                window.checkDiscountPackage("kxinpin")
                url = '/api/proxy/web/kxinpin'
            }

            const exForm = isTkl == 'tkl' ? {invoke_method: 'firstScreen', is_password: true} : {}
            const staForm = isStable == 'stable' ? {stable: 1} : {}

            this.loading = true;
            const data = await this.$fetch(url, {...this.form, invoke_method: 'firstScreen', ...exForm, ...staForm, data_json: typeof(shopInfo) === 'string' ? shopInfo : JSON.stringify(shopInfo)}, 'post')
            this.loading = false;
            
            this.showPt = false;
            // 处理不支持高级版的情况
            if (data.code == 0 && this.activeMarkingType == 1 && data.msg == "该商品不支持高级版") {
                this.showPt = true;
                this.$alert('该商品不支持高级版，已经生成普通版的卡首屏码', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {}
                });
            }

            if (data.code == 0) {
                this.$refs.record.searchSubmit()
                if (isTkl == 'tkl') {
                    this.tklData = { password: data.data.password }
                    this.showQr = false
                    return
                }
                this.showQr = true
                const skuData = data.data.replace(/ /g, '')
                this.qrcode(skuData)
                this.$refs.record.searchSubmit()
            }
        },
        // 生成二维码
        qrcode(data) {
            if (this.$refs.qrcode) {
                this.$refs.qrcode.innerHTML = ''
            }

            let qrcode = new QRCode('qrcode', {
                width: 320,
                height: 320,
                text: data,
                correctLevel: 3,

            })
            this.$refs.qrcode.removeAttribute('title')
            setTimeout(() => {
                this.$refs.qrcode.removeAttribute('title')
            }, 100);
        },
        async getShopInfo() {
            return new Promise(async (resolve, reject) => {
                let result = 'test';

                // TODO: 这里暂时返回 test 不再请求淘宝接口
                resolve(result);
                return 0;

                let id = undefined
                try {
                    if (this.form.url.indexOf('http') === 0) {
                        id = this.getQueryVariable(new URL(this.form.url), 'id')
                    } else {
                        id = this.form.url
                    }
                } catch (e) {
                    this.$message.error("请输入正确的商品链接")
                    return false;
                }

                try {
                    let res = await this.$fetch(`https://acs.m.taobao.com/h5/mtop.taobao.detail.getdetail/6.0/?AntiCreep=true&H5Request=true&type=jsonp&dataType=jsonp&data=%7B%22itemNumId%22%3A%22${id}%22%7D`, {}, 'get')

                    // 正常返回数据
                    if (res && res.data && res.data.skuBase) {
                        result = res;
                    }
                } catch (e) {
                    // 这里接收报错信息, 防止因为淘宝接口报错导致程序中断
                    // 获取商品信息的接口里面报错不处理
                }
                resolve(result);
            })
        },
        async priceLimit(name = 'seniorfirstscreen') {
            const data = await this.$fetch('/api/proxy/web/tool/detail', { name })
            this.codeName = ""
            this.$nextTick(() => {
                this.codeName = name;
            })
            this.pricePreMonth = data.data
        },
        changeHandler(activeMarkType) {
            this.activeMarkingType = activeMarkType

            if(activeMarkType == '2') {
                this.priceLimit('firstscreen')
                this.logMethod = 'firstscreen'
                this.$refs.record.searchForm.invokeName = 'firstscreen'
                return
            }else if (activeMarkType == '3'){
                this.priceLimit('kxinpin')
                this.logMethod = 'kxinpin'
                this.$refs.record.searchForm.invokeName = 'kxinpin'
                return
            } else {
                this.logMethod = 'seniorfirstscreen'
                this.$refs.record.searchForm.invokeName = 'seniorfirstscreen'
            }

            this.priceLimit()
        }
    },
    mounted () {
        this.priceLimit()
    },
}
</script>

<style lang="scss" scoped>
.pause-top-tip {
    color: #ff6600;
    padding: 10px 0;
}
.showqrcode {
    align-items: flex-end;
    justify-content: center;
}
.box-card {
    margin-top: 25px;
    .li-content {
        line-height: 24px;
        color: #999;
    }
}
.qrcode {
    margin: 10px 30px;
}
.item + .item {
    margin-left: 20px;
}
</style>
<style lang="scss">
.tip-card .el-card__header {
    padding: 10px 20px;
    color: #666;
}
.item {
    .el-badge__content.is-fixed {
        right: 0;
        top: 0;
        transform: translateY(-50%) translateX(50%)
    }
}
.bg-none {
    .el-button--danger.is-plain {
        background: none;
    }
    .el-button--danger.is-plain:focus {
        background: #F56C6C;
    }
}
.bg-none:hover {
    .el-button--danger.is-plain {
        background: #F56C6C;
    }
}
</style>
